import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PreinvoiceModel } from './preinvoice.model';
import { AccountsAndTaxesModel } from './accountsandtaxes.model';
import { InvoiceLineModel } from './invoiceline.model';
import { ContactService } from '../../contact/contact/contact.service';
import { PreinvoiceService } from './preinvoice.service';
import { UserContactService } from '../../user/usercontact/usercontact.service';
import { UserCompanyService } from '../../user/usercompany/usercompany.service';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';
import { CoreComponent } from '../../../core/header/core.component';
import { ContactModel } from '../../contact/contact/contact.model';
import { Utils } from '../../../shared/utils';

@Component({
    selector: 'convfact-preinvoice',
    templateUrl: './preinvoice.component.html',
    styleUrls: ['./preinvoice.component.css'],
    standalone: false
})

export class PreinvoiceComponent implements OnInit {
  preinvoice = new PreinvoiceModel;
  accountsAndTaxes = new AccountsAndTaxesModel;
  bankAccounts: BankAccountModel[] = [];
  contactList: ContactModel[] = []
  errors = {};
  spinner: boolean = false;
  ready: boolean = false;
  activity: ActivityModel;
  currentActivityUid: string;

  submit(): void { }

  constructor(private preinvoiceService: PreinvoiceService,
    private contactService: ContactService,
    private userContactService: UserContactService,
    private userCompanyService: UserCompanyService,
    private bankAccountService: BankAccountService,
    private activityService: ActivityService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBar: MatSnackBar,
    private core: CoreComponent
  ) { }

  public displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(error, '', options);
  }

  public saveData(preinvoice: PreinvoiceModel): void {
    this.ready = false;
    /* this.activityService.loadData(this.core.activitySelected).then(response => {
      this.activity = response;
      this.activity.lastPreinvoice = preinvoice.preInvoiceNumber;
      this.activityService.editData(this.core.activitySelected, this.activity);
    }); */

    preinvoice.fiscalYear = this.core.yearSelected;
    preinvoice.activityUid = this.core.activitySelected;

    if (preinvoice.uid == null) {
      this.preinvoiceService.addData(preinvoice)
        .then(preinvoice => {
          this.preinvoice = preinvoice;
          this.preinvoice.activityUid = this.core.activitySelected;
          this.ready = true;
          this.preinvoiceService.saveRequestUpdateValue(false);
          this.returnToIndex();
        })
        .catch(errors => {
          this.ready = true;
          this.preinvoiceService.saveRequestUpdateValue(false);
          if (errors && errors.error && errors.error.message) {
            this.displayError(errors.error.message);
          } else {
            this.displayError('Compruebe los campos obligatorios marcados en rojo');
          }
        })
    } else {
      this.preinvoiceService.editData(preinvoice.uid, preinvoice)
        .then(preinvoice => {
          this.preinvoice = preinvoice;
          this.ready = true;
          this.preinvoiceService.saveRequestUpdateValue(false);
          this.returnToIndex();
        })
        .catch(errors => {
          this.ready = true;
          this.preinvoiceService.saveRequestUpdateValue(false);
          if (errors && errors.error && errors.error.message) {
            this.displayError(errors.error.message);
          } else {
            this.displayError('Compruebe los campos obligatorios marcados en rojo');
          }
        })
    }
  }

  ngOnInit() {
    this.preinvoice.invoiceLines = new Array<InvoiceLineModel>();
    this.preinvoice.invoiceLines.push(new InvoiceLineModel());

    this.bankAccountService.getList().then(
      bankAccounts => {
        this.bankAccounts = bankAccounts.list;
      })

    this.activityService.loadData(this.core.activitySelected).then(response => {
      let loadActivity = new ActivityModel;
      loadActivity = response;
      this.preinvoice.preInvoiceNumber = loadActivity.preinvoiceNumber;
      this.spinner = false;
      this.route.params.subscribe(params => {
        const uid = params['uid'];
        this.spinner = true;
        if (uid != null) {
          this.preinvoiceService.loadData(uid).then(preinvoice => {
            this.preinvoice = preinvoice;
            this.spinner = false;
            this.ready = true;
          })
        } else {
          this.preinvoice.invoiceRelease = new Date();
          this.preinvoice.invoiceExpiration = new Date();

          this.preinvoice.invoiceLines = new Array<InvoiceLineModel>();

          this.userCompanyService.loadData().then(userCompany => {
            this.preinvoice.issuerName = userCompany.companyName;
            this.preinvoice.issuerVatNumber = userCompany.vatNumber;
          })
          this.ready = true;
          this.spinner = false;
        }


        this.userContactService.loadData().then(userContact => {

          if (Utils.IsNullOrEmpty(this.preinvoice.issuerAddress)) {
            this.preinvoice.issuerAddress = userContact.address;
          }

          if (Utils.IsNullOrEmpty(this.preinvoice.issuerPostalCode)) {
            this.preinvoice.issuerPostalCode = userContact.postalCode;
          }

          if (Utils.IsNullOrEmpty(this.preinvoice.issuerLocation)) {
            this.preinvoice.issuerLocation = userContact.location;
          }

          if (Utils.IsNullOrEmpty(this.preinvoice.issuerCountry)) {
            this.preinvoice.issuerCountry = userContact.country;
          }

          if (Utils.IsNullOrEmpty(this.preinvoice.issuerState)) {
            this.preinvoice.issuerState = userContact.state;
          }

        })

      });
    })

    this.preinvoiceService.accountsAndTaxesData().then(accountsAndTaxes => {
      this.accountsAndTaxes = accountsAndTaxes;
    });
  }

  public returnToIndex(): void {
    this.router.navigate(['invoice/preinvoice']);
  }


}
